//@author: devin
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { Item } from "../../../pojo/Item";
import { LocationTooltipResponse } from "../../../services/tooltip.service";
import { S25ImageModule } from "../../s25-image/s25.image.module";
import { S25ItemTooltip } from "./s25.item.tooltip.directive";

@TypeManagerDecorator("s25-space-tooltip")
@Component({
    selector: "s25-space-tooltip",
    template: `
        @if (!loaded()) {
            Loading...
        } @else if (!item()) {
            Could not load location details
        } @else {
            <div class="boxHeader">
                @if (item().image_id) {
                    <div class="defaultLayoutImageWrapper">
                        <s25-ng-image
                            [model]="{
                                imageId: item().image_id!,
                                title: item().conf_name,
                                bootstrap: { point: 'xs', numCols: 3, maxWidth: 100 },
                            }"
                        ></s25-ng-image>
                    </div>
                }
                <div class="boxHeaderName">
                    {{ item().room_short }}
                    <div class="boxHeaderFormalName">
                        {{ item().room_long }}
                    </div>
                </div>
            </div>
            <div class="boxBody">
                @if (item().features) {
                    <div>
                        <div>
                            <span class="c-dataLabel">{{ "Features: " }}</span>
                            <span>{{ item().features }}</span>
                        </div>
                    </div>
                }
                @if (item().layouts) {
                    <div>
                        <div>
                            <span class="c-dataLabel">{{ "Layouts: " }}</span>
                            <span>{{ item().layouts }}</span>
                        </div>
                    </div>
                }
                @if (item().capacity) {
                    <div>
                        <div>
                            <span class="c-dataLabel">{{ "Capacity: " }}</span>
                            <span>{{ item().capacity }}</span>
                        </div>
                    </div>
                }
            </div>
        }
    `,
    host: {
        "[class.locationBox]": "loaded()",
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [S25ImageModule],
})
export class S25SpaceTooltip extends S25ItemTooltip<LocationTooltipResponse> {}
